import { useState } from "react";
import type { CustomerRole } from "../types/api";

export function PaymentChoice({ firmBalance, lawyerQuota, unallocatedBalance = 0, role = "LAWYER", orderAmount, onPay, onClose }: { firmBalance: number; lawyerQuota: number; unallocatedBalance?: number; role?: CustomerRole; orderAmount: number; onPay: () => void | Promise<void>; onClose?: () => void }) {
  const isAdministrator = role === "ORGANIZATION_ADMIN";
  const availableBalance = isAdministrator ? unallocatedBalance : lawyerQuota;
  const disabled = firmBalance < orderAmount || availableBalance < orderAmount;
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [onlineNotice, setOnlineNotice] = useState(false);
  async function pay() {
    if (busy || disabled) return;
    setBusy(true);
    setError("");
    try {
      await onPay();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "支付失败，请稍后重试");
      setBusy(false);
    }
  }
  return <section className="customer-card payment-dialog" role="dialog" aria-modal="true" aria-labelledby="payment-dialog-title">
    <header className="payment-dialog-head"><div><h2 id="payment-dialog-title">确认支付</h2><p>请选择本次查询的支付方式</p></div><button type="button" className="payment-close" aria-label="关闭支付弹窗" onClick={onClose}>×</button></header>
    <div className="payment-dialog-body">
      <div className="payment-order-summary"><span>本次支付</span><strong>¥{orderAmount.toFixed(2)}</strong><small>确认支付后发起查询</small></div>
      <div className="payment-method-list">
        <button className="payment-method payment-method-primary" type="button" disabled={disabled || busy} onClick={() => void pay()}><span className="payment-method-icon">¥</span><span><b>{isAdministrator ? "机构余额支付" : "余额支付"}</b><small>{isAdministrator ? "从机构可分配余额中扣除" : "从本人可用额度中扣除"}</small></span><strong>{busy ? "支付中…" : "立即支付"}</strong></button>
        <button className="payment-method payment-method-online" type="button" onClick={() => setOnlineNotice(true)}><span className="payment-method-icon">支</span><span><b>在线支付 <i>暂未开通</i></b><small>微信、支付宝等在线渠道</small></span><strong>查看说明</strong></button>
      </div>
      <dl className="payment-balance"><div><dt>机构余额</dt><dd>¥{firmBalance.toFixed(2)}</dd></div><div><dt>{isAdministrator ? "机构可分配余额" : "本人可用额度"}</dt><dd>¥{availableBalance.toFixed(2)}</dd></div></dl>
      {disabled && <p className="form-error">{isAdministrator ? "机构余额或机构可分配余额不足" : "余额或本人额度不足"}，请联系管理员充值或调整额度。</p>}
      {error && <p className="form-error">{error}</p>}
    </div>
    <footer className="payment-dialog-foot"><button type="button" onClick={onClose}>暂不支付</button></footer>
    {onlineNotice && <div className="payment-notice-layer" role="alertdialog" aria-modal="true" aria-labelledby="online-payment-notice-title"><section><div className="payment-notice-icon">i</div><h3 id="online-payment-notice-title">在线支付暂未开通</h3><p>在线支付暂未开通，请使用余额支付。</p><button type="button" onClick={() => setOnlineNotice(false)}>我知道了</button></section></div>}
  </section>;
}
